import { render, staticRenderFns } from "./HomeDetail.vue?vue&type=template&id=7895c1ca&"
import script from "./HomeDetail.vue?vue&type=script&lang=js&"
export * from "./HomeDetail.vue?vue&type=script&lang=js&"
import style0 from "./HomeDetail.vue?vue&type=style&index=0&id=7895c1ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports